import { Link } from "react-router-dom";
import { INDUSTRIES_DATA, SERVICES_DATA } from "config/data";
import ImgConsultancy from "assets/images/img-consultancy.jpg";

const ServicesContent = ({ activeTab }) => {
  return (
    <div className="tab-content">
      {activeTab === "services" && (
        <div className="services-section">
          <div className="row g-3">
            {SERVICES_DATA.map((service, index) => (
              <div key={index}>
                <div className="card p-3 shadow-md">
                  <div className="card-icon">
                    <img src={service.image} alt={service.title} className="w-auto" />
                  </div>
                  <div className="card-body">
                    <h4 className="card-title">{service.title}</h4>
                    <p className="card-text">{service.shortDesc}</p>
                    <Link to="#" className="btn btn-link">
                      LEARN MORE
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {activeTab === "industries" && (
        <div className="industries-section row">
          {INDUSTRIES_DATA.map((industry, index) => (
            <div key={index} className="industries-serving col-md-4">
              <span className="industry-icon">
                <img className="h-16" src={industry.img} alt={industry.title} />
              </span>
              <h6>{industry.title}</h6>
              <p>{industry.desc}</p>
            </div>
          ))}
        </div>
      )}

      {activeTab === "consultancy" && (
        <div className="consultancy-section">
          <div className="row align-items-center">
            <div className="col-lg-5">
              <img src={ImgConsultancy} className="w-100" alt="Consultancy" />
            </div>
            <div className="col-lg-7">
              <div className="card p-4 shadow-sm">
                <h3 className="fw-bold text-3xl my-5">Product Strategy</h3>
                <p>
                  "Crafting a clear vision and roadmap for your product’s success. We help businesses define goals, identify market opportunities, and
                  develop strategies that drive innovation and long-term growth." Let me know if you'd like any adjustments!{" "}
                </p>
                <Link href="#contact" className="btn btn-outline-blue mt-5">
                  Get A Quote
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ServicesContent;
